import React from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { PromotionalBanner } from '@yme/molecules/promotional-banner';
export function PromotionalBannerPdpCard(props) {
    const { title, subtitle, image, description, link } = props;
    const { isInfiniteDesktopView } = useWindowSize();
    const promotionalBannerComponent = (React.createElement(PromotionalBanner, { title: title, subtitle: subtitle, description: description, image: image, link: link }));
    return isInfiniteDesktopView ? (React.createElement(GridWrapper, null, promotionalBannerComponent)) : (promotionalBannerComponent);
}
PromotionalBannerPdpCard.displayName = 'PromotionalBannerPdpCard_AEMComponent';
